import React, { useState } from "react";
import { message } from "antd";
import { useHistory } from "react-router-dom";
import { theme } from "../../../config";
import { data } from "../../../constants";
import { useMediaQuery } from "../../../hooks/common";
import { DataPrivacy } from "../../templates/DataPrivacy";

const DataPrivacyPage = () => {
  const [visible, setVisible] = useState(false);
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.mobileAndTablet);
  const bodyContent = (
    <>
      <p>
        <b>Last Update</b>
        <br />
        July 2, 2021
      </p>
      <p>
        Your privacy is important to us. This Data Protection Policy (“Policy”)
        sets out the basis upon which Everbank Vananaz, Inc. (“Everbank
        Vananaz”,”Company”,”We”,”Us” or “Our”) may collect, use, disclose or
        otherwise process personal data of employees and job applicants in
        accordance with the relevant provision of the Data Privacy Act of 2012.
      </p>
      <p>
        Please read the information carefully as this policy explains the
        personal data Everbank Vananaz processes, how Everbank Vananaz processes
        it, for what purposes and how we protect your data.
      </p>
      <h3>
        <b>I. APPLICATION OF THIS POLICY</b>
      </h3>
      <p>
        This Policy applies to all persons engaged in a contract of service with
        the Company (whether on a part-time, temporary, contractual/casual or
        full-time basis/ item positions) and interns and trainees working at or
        affiliated with/attached to us (collectively referred to as “employees”)
        as well as persons who have applied for any such position with the
        Company (“job applicants”), and all references to “employment” shall
        apply equally to internships and traineeships (as maybe applicable).
      </p>
      <h3>
        <b>II. PERSONAL DATA</b>
      </h3>
      <p>
        As used in this Policy, “personal data” means data , whether true or
        not, about an employee or a job applicant who can be identified:
      </p>
      <p style={{ marginLeft: 20 }}>
        (a) from that data; or <br /> (b) from the data and other information to
        which we have or are likely to have access.
      </p>
      <p>
        If you are an employee, personal data which we may collect in the
        context of your employment with us includes, without limitation, your:
      </p>
      <p style={{ marginLeft: 20 }}>
        (a) name, date of birth, civil status, address, contact number
        <br /> (b) resume, educational qualifications, professional
        qualifications and certifications and employment and/or character
        reference educational background, LinkedIn URL, address, contact number,
        character references;
        <br /> (c) mailing address, telephone numbers, email address and other
        contact details;
        <br /> (d) criminal records and/or clearances from the National Bureau
        of Investigation (NBI), Police and Barangay;
        <br /> (e) employment and training history;
        <br /> (f) work-related health issues and disabilities, including
        records of Annual Physical Exam and illnesses;
        <br /> (g) details of your next-of-kin, spouse and other family members;
        <br /> (h) result of exams and other diagnostic test/s for aptitude, IQ,
        behavior, etc;
        <br /> (i) Photographs and images via CCTV and other similar recording
        devices and processes which may be observed when visiting our offices
        and/or using our other facilities;
        <br /> (j) salary information and bank account details;
        <br /> (k) records on leave of absence from work;
        <br /> (l) Disciplinary records; and
        <br /> (m) Any additional information provided to the Company by you as
        a job applicant (that is, prior to being engaged as an employee)
      </p>
      <p>
        If you are a job applicant, personal data which we may collect includes,
        without limitation, your:
      </p>
      <p style={{ marginLeft: 20 }}>
        (a) name, date of birth, civil status, address, contact number
        <br /> (b) resume, educational qualifications, professional
        qualifications and certifications and employment and/or character
        reference educational background, LinkedIn URL, address, contact number,
        character references;
        <br /> (c) mailing address, telephone numbers, email address and other
        contact details;
        <br /> (d) criminal records and/or clearances from the National Bureau
        of Investigation (NBI), Police and Barangay;
        <br /> (e) employment and training history;
        <br /> (f) work-related health issues and disabilities;
        <br /> (g) Family background for your next-of-kin and list of qualified
        dependent/s including their pertinent information;
        <br /> (h) result of exams and other diagnostic test/s for aptitude, IQ,
        behavior, etc. and photographs and images via CCTV and other similar
        recording devices and processes which may be observed when visiting our
        offices and/or using our other facilities;
      </p>
      <p>
        Other terms used in this Policy shall have the meanings given to them in
        the Data Protection Act (where the context so permits).
      </p>
      <h3>
        <b>III. COLLECTION, USE AND DISCLOSURE OF PERSONAL DATA</b>
      </h3>
      <p>Everbank Vananaz generally collects personal data that:</p>
      <p style={{ marginLeft: 20 }}>
        (a) you knowingly and voluntarily provide in the course of or in
        connection with your employment or job application with the Company or
        any of its subsidiaries, network affiliates, service providers, or via a
        third party who has been duly authorized by you to disclose your
        personal data to the Company (your “authorized representative”, which
        may include your job placement agent, party making a referral for your
        application), after
        <br />
        (i) you (or your authorized representative) have been notified of the
        purposes for which the data is collected, and <br /> (ii) you (or your
        authorized representative) have provided written consent to the
        collection and usage of your personal data for those purposes, or
        <br />
        (b) collection and use of personal data without consent is permitted or
        required by the Data Privacy Law or other applicable laws. We shall seek
        your consent before collecting any additional personal data and before
        using your personal data for a purpose which has not been notified to
        you (except where permitted or authorized by law).
      </p>
      <p>
        If you are a job applicant, your personal data will be collected and
        used by the Company for the following purposes and we may disclose your
        personal data to third parties where necessary for the following
        purposes:
      </p>
      <p style={{ marginLeft: 20 }}>
        (a) assessing and evaluating your suitability for employment in any
        current or prospective position within the organization; and
        <br /> (b) all administrative and human resources related matters within
        our organization, including administering payroll, granting access to
        our premises and computer systems, processing leave applications,
        administering your insurance and other benefits (statutory or
        otherwise), processing your claims and expenses, investigating any acts
        or defaults (or suspected acts or defaults) and developing human
        resource and other Company policies;
        <br /> (c) managing and terminating our employment relationship with
        you, including monitoring your internet access and your use of our
        intranet email to investigate potential contraventions of our internal
        or external compliance regulations, and resolving any employment related
        grievances;
        <br /> (d) assessing and evaluating your suitability for
        employment/appointment or continued employment/appointment in any
        position within our organization;
        <br /> (e) ensuring business continuity for our organization in the
        event that your employment with us is or will be terminated;
        <br /> (f) performing obligations under or in connection with the
        provision of our goods or services to our clients;
        <br /> (g) facilitating any proposed or confirmed merger, acquisition or
        business asset transaction involving any part of our organization, or
        corporate restructuring process; and
        <br /> (h) facilitating our compliance with any laws, customs and
        regulations which may be applicable to us.
      </p>
      <p>
        The purposes listed in the above clauses may continue to apply even in
        situations where your relationship with the Company (for example,
        pursuant to a contract) has been terminated or altered in any way, for a
        reasonable period thereafter (including, where applicable, a period to
        enable us to enforce our rights under any contract with you).
      </p>
      <h3>
        <b>IV. ACCESS TO AND CORRECTION PERSONAL DATA</b>
      </h3>
      <p>If you wish to make:</p>
      <p style={{ marginLeft: 20 }}>
        (a) an access request for access to a copy of the personal data which we
        hold about you or information about the ways in which we use or disclose
        your personal data, or
        <br /> (b) a correction request to correct or update any of your
        personal data which we hold, you may submit your request in writing or
        via email to our Data Protection Officer at the contact details provided
        below.
      </p>
      <p>
        Please be advised that depending on the request that is being made, we
        will only need to provide you with access to the personal data contained
        in the documents requested, and not to the entire document itself. For
        instance, the Company may not be obliged to provide the employee with
        access to the disciplinary records, investigation reports, or decisions
        to terminate, that the organization has created for evaluative and/or
        investigative purposes of the employee.
      </p>
      <h3>
        <b>V. WITHDRAWING CONSENT BY JOB APPLICANTS</b>
      </h3>
      <p>
        The consent that you provide for the collection, use and disclosure of
        your personal data will remain valid until such time it is being
        withdrawn by you in writing. If you are a job applicant, you may
        withdraw consent and request us to stop using and/or disclosing your
        personal data for any or all of the purposes listed above by submitting
        your request in writing or via email to our Data Protection Officer at
        the contact details provided below.
      </p>
      <p>
        Upon receipt of your written request to withdraw your consent, we may
        require reasonable time (depending on the complexity of the request and
        its impact on our relationship with you) for your request to be
        processed and for us to notify you of the consequences of us acceding to
        the same, including any legal consequences which may affect your rights
        and liabilities to us. In general, we shall seek to process and effect
        your request within five (5) days from receipt of such request.
      </p>
      <p>
        While we respect your decision to withdraw your consent, please note
        that depending on the nature and extent of your request, we may not be
        in a position to process your job application (as the case may be). We
        shall, in such circumstances, notify you before completing the
        processing of your request (as outlined above). Should you decide to
        cancel your withdrawal of consent, please inform us in writing in the
        manner described above.
      </p>
      <p>
        Please note that withdrawing consent does not affect our right to
        continue to collect, use and disclose personal data where such
        collection, use and disclosure without consent is permitted or required
        under applicable laws.
      </p>
      <h3>
        <b>VI. RETENTION OF PERSONAL DATA</b>
      </h3>
      <p>
        We may retain your personal data for as long as it is necessary to
        fulfil the purposes for which they were collected, or as required or
        permitted by applicable laws.
      </p>
      <p>
        We will cease to retain your personal data, or remove the means by which
        the data can be associated with you, as soon as it is reasonable to
        assume that such retention no longer serves the purposes for which the
        personal data were collected, and are no longer necessary for legal or
        business purposes.
      </p>
      <h3>
        <b>VII. PROTECTION OF PERSONAL DATA</b>
      </h3>
      <p>
        To safeguard your personal data from unauthorized access, collection,
        use, disclosure, copying, modification, disposal or similar risks, we
        have introduced appropriate administrative, physical and technical
        measures such as up-to-date antivirus protection, encryption and the use
        of privacy filters to secure all storage and transmission of personal
        data by us, and disclosing personal data both internally and to our
        authorized third party service providers and agents only on a
        need-to-know basis.
      </p>
      <p>
        You should be aware, however, that no method of transmission over the
        Internet or method of electronic storage is completely secure. While
        security cannot be guaranteed, we strive to protect the security of your
        information and are constantly reviewing and enhancing our information
        security measures. Once we have received your information, we will use
        strict procedures and security features to try to prevent unauthorized
        access. We urge you to be careful and responsible whenever you are
        online, especially when using a shared computer and/or public Wi-Fi
        network connection in places like cafes, airports, hotels and libraries.
      </p>
      <h3>
        <b>VIII. ACCURACY OF PERSONAL DATA</b>
      </h3>
      <p>
        We generally rely on personal data provided by you (or your authorised
        representative). In order to ensure that your personal data is current,
        complete and accurate, please update us if there are changes to your
        personal data by informing our Data Protection Officer in writing or via
        email at the contact details provided below.
      </p>
      <h3>
        <b>IX. YOUR RIGHTS AS DATA SUBJECT</b>
      </h3>
      <p>
        The Personal Information you have provided to us shall be retained for
        as long as necessary to fulfill the purposes for which it was collected,
        to comply with our legal obligations, resolve disputes, and enforce our
        agreements with third parties. You may exercise your particular Right to
        Access, Modify and Delete the Personal Information, by contacting us
        through the information provided below:
      </p>
      <p>
        Renilo M. Taniola Jr.
        <br />
        Manager and Data Protection Officer <br />
        Everbank Vananaz, Inc. <br />
        Email: <u>enzo@vananaz.com</u> <br />
        Mobile: (+63) 917 701 4012
      </p>
      <h3>
        <b>X. CHANGES TO OUR PRIVACY POLICY</b>
      </h3>
      <p>
        This Policy applies in conjunction with any other noticies, policies,
        contractual clauses and consent clauses that apply in relation to the
        collection, use and disclosure of your personal data by us.
      </p>
      <p>
        At the Company’s discretion, we may amend, interpret, modify or withdraw
        any portion of this Data Privacy Policy at any time without any prior
        notice. You may determine if any such revision has taken place by
        referring to the date on which this Notice was last updated. Your
        continued employment and participation in our recruitment process
        constitute your acknowledgment and acceptance of such changes.
      </p>
    </>
  );

  let history = useHistory();
  const routeChange = () => {
    if (navigator.onLine) {
      let path = "details";
      return history.push(path);
    }
    message.config({ duration: 2, maxCount: 1 });
    message.error(data.toastNetworkErrorMessage);
  };

  return (
    <DataPrivacy
      onClickHere={() => setVisible(true)}
      onAgree={routeChange}
      modalVisible={visible}
      onModalClose={() => setVisible(false)}
      modalTitle="EVERBANK VANANAZ, INC. DATA PROTECTION POLICY FOR EMPLOYEES AND JOB APPLICANTS"
      modalBody={bodyContent}
      modalHeight={isMobileOrTablet ? "" : "696px"}
    />
  );
};

export default DataPrivacyPage;
